import { Stack, Button, Group, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { EditInsuranceFormData } from "../types"
import { DatePickerInput } from "@mantine/dates"
import { InfinitePersonSingleSelect } from "@components/SelectFromQuery/InfinitePersonSingleSelect"
import { DefaultModal } from "@components/default-modal"

interface CreateInsuranceModalProps {
  opened: boolean
  onClose: () => void
  editInsuranceFormData: EditInsuranceFormData
  setEditInsuranceFormData: (data: EditInsuranceFormData) => void
  createInsuranceMutation: {
    isPending: boolean
    error: unknown
    reset?: () => void
  }
  onCreate: (data: EditInsuranceFormData) => void
}

export function CreateInsuranceModal({
  opened,
  onClose,
  editInsuranceFormData,
  setEditInsuranceFormData,
  createInsuranceMutation,
  onCreate,
}: CreateInsuranceModalProps) {
  const { t } = useTranslation("app_server")

  return (
    <DefaultModal
      opened={opened}
      onClose={() => {
        onClose()
        createInsuranceMutation.reset?.()
      }}
      title={t("Insurance")}
    >
      {opened && (
        <Stack gap="md">
          <InfinitePersonSingleSelect
            label={t("Owner")}
            value={editInsuranceFormData.insuredPersonId?.toString() ?? ""}
            onSelectionChange={(value) =>
              setEditInsuranceFormData({
                ...editInsuranceFormData,
                insuredPersonId: value ? parseInt(value) : null,
              })
            }
            searchable
            required
          />

          <DatePickerInput
            label={t("ValidSince")}
            value={editInsuranceFormData.startDate ?? undefined}
            onChange={(value) =>
              setEditInsuranceFormData({
                ...editInsuranceFormData,
                startDate: value ? new Date(value) : null,
              })
            }
          />

          <DatePickerInput
            label={t("ValidTo")}
            value={editInsuranceFormData.endDate ?? undefined}
            onChange={(value) =>
              setEditInsuranceFormData({
                ...editInsuranceFormData,
                endDate: value ? new Date(value) : null,
              })
            }
          />

          {createInsuranceMutation.error ? (
            <Text color="red" size="sm">
              Failed to create insurance
            </Text>
          ) : null}

          <Group justify="flex-end" gap="md">
            <Button variant="default" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button
              onClick={() => onCreate(editInsuranceFormData)}
              loading={createInsuranceMutation.isPending}
            >
              {t("Save")}
            </Button>
          </Group>
        </Stack>
      )}
    </DefaultModal>
  )
}
